import { useState } from 'react';
import './LoginForm.css';
import LogoBanner from '../LogoBanner/LogoBanner';
import { validaEmail, validaSenha } from '../../validations/basicAuthValidations';
import NotifyUtils from '../../utils/NotifyUtils';
import { useTranslation } from 'react-i18next';

const LoginForm = ({ onLogin: handleLogin }) => {

  const [ loading, setLoading ] = useState(false);
  const { t } = useTranslation();

  const [ contadorLogin, setContadorLogin ] = useState(0);

  const [ lastTryTime, setLastTryTime ] = useState(new Date().getTime());

  const timeOutTime = 30000;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [emailInvalido, setEmailInvalido] = useState(false);
  const [senhaInvalida, setSenhaInvalida] = useState(false);

  const handleTogglePassword = () => {
    // Inverte o estado para mostrar ou ocultar a senha
    setShowPassword(!showPassword);
  };

  const handleLoginClick = async () => {
    if(loading) {
      NotifyUtils.aviso(t("aguarde-processamento"));
      return;
    };

    setLoading(true);

    const emailValido = validaEmail(email);
    const senhaValida = validaSenha(password);

    setEmailInvalido(!emailValido);
    setSenhaInvalida(!senhaValida);

    if (emailValido && senhaValida) {
      const currentTime = new Date().getTime();
      if(contadorLogin > 5) {
        const timeBetweenLogins = currentTime - lastTryTime;
        const tempoRestante = Math.floor((timeBetweenLogins - timeOutTime) / 1000);
  
        if(timeBetweenLogins < timeOutTime) {
          NotifyUtils.erro(t("limite-tentativas", { tempo: tempoRestante * -1 }));
          setLoading(false);
          return;
        }
      }
      
      setLastTryTime(currentTime);
      await handleLogin(email, password);
      setLoading(false);
    } else {
      NotifyUtils.erro(`${retornaStringInvalido(emailValido, senhaValida)}`);
      setLoading(false);
    }

    setContadorLogin(contadorLogin + 1);
  };

  const retornaStringInvalido = (emailValido, senhaValida) => {
    let retorno = "";

    if(!emailValido && senhaValida) retorno += t("email-invalido");
    if(emailValido && !senhaValida) retorno += t("senha-invalido");

    if(!emailValido && !senhaValida) {
      retorno = t("senha-email-invalido");
    }

    return retorno;
  }

  const handleKeyPress = async (e) => {
    if(e.key === "Enter") {
      await handleLoginClick();
    }
  };

  const naoDisponivel = (event) => {
    event.preventDefault();
    NotifyUtils.custom(t("em-desenvolvimento"));
  }

  return (
    <div className="login-form" onKeyDown={handleKeyPress}>
      <LogoBanner  />

      <div className="input-container">
        <i className="login-user-icon material-icons-outlined">person</i>
        <input
          className={emailInvalido ? "invalido1" : null}
          type="email"
          placeholder={t("email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="input-container">
        <i className="login-lock-icon material-icons-outlined">lock</i>
        <input
          className={senhaInvalida ? "invalidos" : null}
          type={showPassword ? "text" : "password"}
          placeholder={t("senha")}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <i className={`login-eye-icon ${showPassword ? 'material-icons' : 'material-icons-outlined'} ${showPassword ? 'olho-aberto' : null}`} onClick={handleTogglePassword}>{showPassword ? "visibility" : "visibility_off"}</i>
      </div>

      <a onClick={(e) => {naoDisponivel(e)}} href="/recuperar-senha">{t("botao-esqueceu-senha")}</a>
      <button onClick={handleLoginClick}>{t("botao-entrar")}</button>
    </div>
  );
};

export default LoginForm;
